import { Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { convertAmountToWords, displayFormattedDate, formatCurrency, formatDate, isEmpty } from '../../generalFunctions';
import Header from './common/Header';
import Signature from './common/Signature';
import font from "../../assests/fonts/ARLRDBD.ttf";
import logo from "../../assests/images/LuktukeLogo.png";
import { PDF_ALL_MARGIN, PDF_LEFT_MARGIN, PDF_RIGHT_MARGIN } from '../../constants';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        padding: 10
    },
    detailColumn: {
        flexDirection: 'column',
        flexGrow: 15,
    },
    linkColumn: {
        flexDirection: 'column',
        flexGrow: 2,
        alignSelf: 'flex-end',
        justifySelf: 'flex-end',
    },
    title: {
        fontSize: 10,
        fontWeight: "bold",
        borderStyle: "solid",
        borderColor: "black",
        borderWidth: 2,
        maxWidth: 160,
        textAlign: "left",
        padding: 10,
        marginBottom: 1
    },
    subtitle: {
        flexDirection: "column",
        flexGrow: 2,
        fontSize: 7,
        marginBottom: 1
    },
    image: {
        alignSelf: "flex-start",
        width: 130,
        height: 80
    },
    ronumber: {
        flexDirection: "column",
        //flexGrow: 1,
        fontSize: 10,
        fontWeight: "bold",
        //marginLeft: 3,
    },
    rowView: {
        display: 'flex', flexDirection: 'row', borderTop: '1px solid #000', paddingTop: 3, paddingBottom: 3, textAlign: "center"
    }
});

const PaymentVoucher = (props) => {
    let bills = props.data.billIds;

    bills.forEach(bill => {
        bill.paymentAmount = formatCurrency(bill.paymentAmount);
        bill.deductionAmount = formatCurrency(bill.deductionAmount);
        bill.netAmount = formatCurrency(bill.netAmount);
    })

    bills.push({
        paymentAmount: "Total:",
        deductionAmount: formatCurrency(props.data.deductionAmount),
        netAmount: formatCurrency(props.data.finalAmount)
    });

    const tableData = {
        columnName: ["Bill No.", "Payable Amt.", "Deduction Amt.", "Paid Amt."],
        column: ["billNumber", "paymentAmount", "deductionAmount", "netAmount"],
        data: bills
    }

    return (
        <Page style={{ paddingLeft: PDF_LEFT_MARGIN, margin: PDF_ALL_MARGIN, paddingRight: PDF_RIGHT_MARGIN }} id={props.data.id} size="A4">
            <View style={{ border: 2, padding: 5 }}>
                <View style={styles.container}>
                    <View style={styles.detailColumn}>
                        <View>
                            <Text style={{ alignSelf: "flex-start", fontFamily: "ARLRDBD", fontSize: 13 }} >{"PAYMENT VOUCHER" + ` (${props.data.type})`}</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 4 }}>
                            <Text style={{ fontSize: 10, fontWeight: "bold" }}>Date: </Text>
                            <Text style={{ fontSize: 10 }}>{formatDate(props.data.voucherDate)}</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 4 }}>
                            <Text style={{ fontSize: 10, fontWeight: "bold" }}>Voucher No. </Text>
                            <Text style={{ fontSize: 10 }}>{props.data.id}</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 4 }}>
                            <Text style={{ fontSize: 10 }}>To,</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 2, width: 200 }}>
                            <Text style={{ fontSize: 10, fontWeight: "bold" }}>{props.data.creditor}</Text>
                        </View>
                    </View>
                    <View style={styles.linkColumn}>
                        <Image
                            src={logo}
                            style={styles.image}
                        />
                    </View>
                </View>

                <View style={{ flexDirection: "row", padding: 10, marginBottom: 5 }}>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "column",
                        marginRight: 20,
                        flexGrow: 1,
                        lineHeight: 2
                    }}>
                        {`We have sent Rs. ${formatCurrency(props.data.finalAmount)} only through ${props.data.type} in your A/C towards the payment of your following bill / bills`}
                    </Text>
                </View>
                <Fragment>
                    <View style={styles.rowView}>
                        {tableData["columnName"].map((c) => <Text style={{
                            width: `${100 / tableData["columnName"].length}%`, fontSize: 10
                        }}>{c.toUpperCase()}</Text>)}
                    </View>
                    {tableData["data"].map((rowData, index) => <>
                        <View style={styles.rowView}>
                            {tableData["column"].map((c) =>
                                <Text style={{ width: `${100 / tableData["column"].length}%`, fontSize: 10 }} >{rowData[c]}</Text>
                            )}
                        </View>
                    </>)}
                </Fragment>
                <View style={{ flexDirection: "row", marginRight: 20, marginTop: 2 }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>{props.data.narration}</Text>
                </View>
                {/* <View style={{ flexDirection: "column", width: "50%", alignItems: "flex-end" }}>
                    <Signature />
                </View> */}
            </View>
        </Page>
    );
}

export default PaymentVoucher;